// Campus photo for /colleges/ball-state-university: CC BY-SA 4.0, by Momoneymoproblemz, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMcKinley_Avenue%2C_Ball_State_University%2C_2014.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/ball-state-university/; credited under the photo.
const photo = {
    "slug": "ball-state-university",
    "alt": "McKinley Avenue running through the Ball State University campus in Muncie, Indiana",
    "src": "/colleges/ball-state-university/campus-1600.webp",
    "srcSmall": "/colleges/ball-state-university/campus-800.webp",
    "srcMid": "/colleges/ball-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/ball-state-university/og.jpg",
    "title": "McKinley Avenue, Ball State University, 2014",
    "author": "Momoneymoproblemz",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMcKinley_Avenue%2C_Ball_State_University%2C_2014.JPG",
    "read": "2026-10-01"
};

export default photo;
